import { cn } from '@quadralize/utils'
import { MenuDots } from '@solar-icons/react'
import { AnimatePresence, motion } from 'framer-motion'
import type { MobileNavProps } from '../types'

export function MobileNav({ items, currentPath, onNavigate, onToggleMenu }: MobileNavProps) {
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-bg-base/80 backdrop-blur-xl border-t border-border-subtle safe-area-bottom shadow-[0_-4px_20px_0_rgba(0,0,0,0.05)]">
      <div className="flex items-center justify-around h-16 px-4">
        {items.map((item) => {
          const isActive = currentPath === item.path

          return (
            <button
              key={item.path}
              type="button"
              onClick={() => onNavigate(item.path)}
              className={cn(
                'flex flex-col items-center justify-center gap-1 min-w-16 h-full relative transition-colors',
                isActive ? 'text-primary' : 'text-text-tertiary',
              )}
            >
              <AnimatePresence>
                {isActive && (
                  <motion.div
                    layoutId="active-nav-glow"
                    className="absolute inset-0 bg-primary/10 rounded-2xl blur-xl"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                  />
                )}
              </AnimatePresence>

              {(() => {
                const Icon = item.icon
                return (
                  <Icon
                    className={cn(
                      'h-6 w-6 relative z-10 transition-transform',
                      isActive && 'scale-110',
                    )}
                    weight={isActive ? 'Bold' : 'Outline'}
                  />
                )
              })()}
              <span className="text-[10px] font-bold leading-none relative z-10">{item.label}</span>

              {isActive && (
                <motion.div
                  layoutId="active-nav-indicator"
                  className="absolute -top-px w-8 h-0.75 bg-primary rounded-full"
                />
              )}
            </button>
          )
        })}

        <button
          type="button"
          onClick={onToggleMenu}
          className="flex flex-col items-center justify-center gap-1 min-w-16 h-full text-text-tertiary hover:text-text-primary transition-colors"
        >
          <MenuDots className="h-6 w-6" />
          <span className="text-[10px] font-bold leading-none">Mais</span>
        </button>
      </div>
    </nav>
  )
}
